export default __webpack_public_path__ + "static/media/777 milestone badge.2dce8036.svg";